import * as classes from './index.scss';
import * as React from 'react';
import { observer } from 'mobx-react';
import AvatarIcon from 'shuyun-ep-icons/react/Avatar';
import * as i18nMap from './i18n.map';
import { LanguageStore } from '@common/stores/language';



@observer
export default class Kickout extends React.Component {
  public render() {
    const { translate } = LanguageStore.instance;

    const mainDescription = translate(i18nMap.mainDescription);
    const subDescription = translate(i18nMap.subDescription);

    return (
      <div className={classes.container}>
        <AvatarIcon className={classes.icon} />
        <h3 className={classes.h}>{mainDescription}</h3>
        <p className={classes.desc}>{subDescription}</p>
      </div>
    );
  }
}

